import { ApiService } from './api.service';
import type { FormUpdateRequest, FormView } from '@/types/form';

class FormService extends ApiService {
  public async getForm(churchId: string): Promise<FormView> {
    const url = `/api/v1/churches/${churchId}/form`;
    const response = await this.get<FormView>(url);
    return response.data;
  }

  public async updateForm(churchId: string, payload: FormUpdateRequest): Promise<FormView> {
    const url = `/api/v1/churches/${churchId}/form`;
    const response = await this.put<FormView>(url, payload);
    return response.data;
  }
}

export const formService = new FormService();
